/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { AuthNumberGenerationDialogComponent } from './auth-number-generation-dialog.component';

export const authNumberGenerationDialog = createDialogRoute({
  component: AuthNumberGenerationDialogComponent,
});
